export interface YAPRoute
{
    path: string;
    privilege: string;
    pathSansParameters?: string;
}

export const ROUTES = {
    SECURE: {
        ACCOUNT: {
            BULK: {path: '/secure/payment/bulk', privilege: 'ACCOUNT_SEARCH'},
            LIST: {path: '/secure/payment/list', privilege: 'ACCOUNT_SEARCH'},
            ECOMMERCE: {path: '/secure/payment/ecommerce', privilege: 'ACCOUNT_SEARCH'},
            ECOMMERCE_DASHBOARD: {path: '/secure/ecommerce/dashboard', privilege: 'ECOMMERCE_DASHBOARD_READ'},
            REFUND_DASHBOARD: {path: '/secure/ecommerce/refund-dashboard', privilege: 'ECOMMERCE_DASHBOARD_READ'},
            REFUND_TRANSACTIONS: {path: '/secure/payment/refunds', privilege: 'ACCOUNT_SEARCH'},
            ECOMMERCE_FLOAT_MONITORING: {
                path: '/secure/ecommerce/float-monitoring',
                privilege: 'FLOAT_DASHBOARD_READ'
            },
            CREATE: {path: '/secure/payment/create', privilege: 'ACCOUNT_CREATE'},
            QUICK_PAY_CREATE: {path: '/secure/payment/create/quick-pay', privilege: 'ACCOUNT_CREATE'},
            QUICK_PAY_SEND: {
                path: '/secure/payment/send/quick-pay/:id',
                pathSansParameters: '/secure/payment/send/quick-pay',
                privilege: 'ACCOUNT_CREATE'
            },
            VIEW: {
                path: '/secure/payment/view/:id',
                pathSansParameters: '/secure/payment/view',
                privilege: 'ACCOUNT_READ'
            },
            SEND: {
                path: '/secure/payment/send/:id',
                pathSansParameters: '/secure/payment/send',
                privilege: 'ACCOUNT_CREATE'
            },
            EDIT: {
                path: '/secure/payment/edit/:id',
                pathSansParameters: '/secure/payment/edit',
                privilege: 'ACCOUNT_UPDATE'
            },
            UPLOAD_REQUESTS_FILE: {path: '/secure/payment/upload/requests', privilege: 'ACCOUNT_UPLOAD'},
            READONLY_CREATE: {path: '/secure/payment/create', privilege: 'READ_ONLY'},
            READONLY_UPLOAD_REQUESTS_FILE: {path: '/secure/payment/upload/requests', privilege: 'READ_ONLY'}
        },
        QR: {
            CREATE: {path: '/secure/qr/create', privilege: 'QR_CREATE'},
            LIST: {path: '/secure/qr', privilege: 'QR_SEARCH'},
            PAYMENTS: {path: '/secure/qr/payments', privilege: 'ACCOUNT_SEARCH'},
            EDIT: {path: '/secure/qr/edit/:id', pathSansParameters: '/secure/qr/edit', privilege: 'QR_EDIT'},
            DETAILS: {path: '/secure/qr/details/:id', pathSansParameters: '/secure/qr/details', privilege: 'QR_VIEW'}
        },
        SETTLEMENT_BATCH: {
            LIST: {path: '/secure/settlement/batch', privilege: 'SETTLEMENT_BATCH_READ'},
            VIEW: {
                path: '/secure/settlement/batch/:id',
                pathSansParameters: '/secure/settlement/batch',
                privilege: 'SETTLEMENT_BATCH_READ'
            },
        },
        USER: {
            LIST: {path: '/secure/user', privilege: 'USER_READ'},
            CREATE: {path: '/secure/user/create', privilege: 'USER_CREATE'},
            EDIT: {path: '/secure/user/edit/:id', pathSansParameters: '/secure/user/edit', privilege: 'USER_UPDATE'},
            INVITATION: {
                LIST: {path: '/secure/user/invitation', privilege: 'USER_INVITATION_READ'}
            },
        },
        BUSINESS: {
            EDIT: {path: '/secure/business/settings', privilege: 'BUSINESS_UPDATE'},
            EDIT_BANKING_DETAILS: {path: '/secure/business/settings', privilege: 'BUSINESS_UPDATE_BANKING_DETAILS'},
            EDIT_FICA_DETAILS: {path: '/secure/businessAppRoutes/settings', privilege: 'BUSINESS_UPDATE_FICA_DETAILS'},
        },
        HOME: {
            VIEW: {path: '/secure/home', privilege: 'ANONYMOUS'},
        },
        ECOMMERCE: {
            LANDING: {path: '/secure/ecommerce/landing', privilege: 'ANONYMOUS'},
            KYC: {path: '/secure/ecommerce/kyc', privilege: 'ANONYMOUS'},
            KYC_VIEW: {path: '/secure/ecommerce/kyc/view', privilege: 'ANONYMOUS'},
        },
        INVOICES: {
            LIST: {path: '/secure/invoices', privilege: 'INVOICE_READ'}
        },
        PURCHASE: {
            MESSAGE_BUNDLES: {path: '/secure/purchase/messageBundles', privilege: 'MESSAGE_BUNDLES_READ'}
        },
        FEES: {
            VIEW: {path: '/secure/fees', privilege: 'FEES_READ'}
        },
        WALKTHROUGH: {path: '/secure/walkthrough', privilege: 'ANONYMOUS'}
    },
    PUBLIC: {
        LOGIN: {path: '/public/login', privilege: 'ANONYMOUS'},
        SIGNUP: {path: '/public/signup', privilege: 'ANONYMOUS'},
        SIGNUP_ECOMMERCE: {path: '/public/signup/ecommerce', privilege: 'ANONYMOUS'},
        SIGNUP_VERIFY_EMAIL: {path: '/public/signup/verify-email', privilege: 'ANONYMOUS'},
        SIGNUP_INTEGRATOR_MERCHANT: {
            path: '/public/signup/:integratorUuid',
            privilege: 'ANONYMOUS'
        },
        SIGNUP_FOR_INTEGRATOR: {
            path: '/public/signup/:merchantIdentifier/:integratorPrefix/:integratorUuid',
            privilege: 'ANONYMOUS'
        },
        SIGNUPWALKTHROUGH: {path: '/public/signup/walkthrough', privilege: 'ANONYMOUS'},
        REGISTER: {path: '/public/user/register', privilege: 'ANONYMOUS'},
        ACCOUNTRECOVERY: {path: '/public/accountrecovery', privilege: 'ANONYMOUS'},
        PASSWORDRESET: {path: '/public/passwordreset', privilege: 'ANONYMOUS'},
        FAQS: {path: '/public/faqs', privilege: 'ANONYMOUS'},
        INVOICE: {path: '/public/invoice/:invoiceToken', privilege: 'ANONYMOUS'},
        WALKTHROUGH: {path: '/public/walkthrough', privilege: 'ANONYMOUS'}
    }
};
